import * as React from "react";
import type { SVGProps } from "react";
const SvgPlay = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#play_svg__a)">
      <path
        fill="currentColor"
        d="M5.5 21a1 1 0 0 1-.863-.496A1 1 0 0 1 4.5 20V4a1 1 0 0 1 .51-.87 1 1 0 0 1 1 0l13 8a1 1 0 0 1 0 1.7l-13 8a1 1 0 0 1-.51.17m1-15.21v12.42L16.59 12z"
      />
    </g>
    <defs>
      <clipPath id="play_svg__a">
        <path fill="#fff" d="M4.5 3h15v18h-15z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgPlay;
